// extracted by mini-css-extract-plugin
export default {"adminFooter":"AdminFooter_adminFooter__maK+H"};